import React from 'react';
import { CheckCircle, Clock, ThumbsUp, Headphones, Shield } from 'lucide-react';
const WhyChooseUsSection = () => {
  const reasons = [{
    icon: <CheckCircle className="w-6 h-6" data-id="element-342" />,
    title: 'Certified Expertise',
    description: 'Our technicians are certified by leading manufacturers and undergo continuous training to stay current with the latest technologies.'
  }, {
    icon: <Clock className="w-6 h-6" data-id="element-343" />,
    title: 'Prompt & Reliable',
    description: 'We value your time and pride ourselves on punctual service with clear communication throughout your project.'
  }, {
    icon: <div className="w-6 h-6" data-id="element-344" />,
    title: 'Quality Installations',
    description: 'We use only premium materials and follow industry best practices to ensure your systems perform flawlessly for years.'
  }, {
    icon: <ThumbsUp className="w-6 h-6" data-id="element-345" />,
    title: 'Satisfaction Guaranteed',
    description: 'We stand behind our work with comprehensive warranties and ongoing support for all installations.'
  }, {
    icon: <Headphones className="w-6 h-6" data-id="element-346" />,
    title: 'Responsive Support',
    description: 'Our dedicated support team is available to quickly address any questions or concerns you may have.'
  }, {
    icon: <Shield className="w-6 h-6" data-id="element-347" />,
    title: 'Licensed & Insured',
    description: 'Your protected because we carry insurance coverage and are state licensing.'
  }];
  return <section className="py-16 md:py-24 bg-white" data-id="element-348">
      <div className="container mx-auto px-4" data-id="element-349">
        <div className="text-center mb-16" data-id="element-350">
          <p className="text-blue-600 font-semibold mb-2" data-id="element-351">WHY CHOOSE US</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-352">
            The Premier Choice for AV & Smart Technology
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto" data-id="element-353">
            With over 20 years of experience serving Southwest Florida, we
            deliver exceptional results through expertise, quality, and
            outstanding customer service.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-10" data-id="element-354">
          {reasons.map((reason, index) => <div key={index} className="flex" data-id="element-355">
              <div className="mr-4 text-blue-600 flex-shrink-0" data-id="element-356">
                {reason.icon}
              </div>
              <div data-id="element-357">
                <h3 className="text-xl font-bold mb-2" data-id="element-358">{reason.title}</h3>
                <p className="text-gray-600" data-id="element-359">{reason.description}</p>
              </div>
            </div>)}
        </div>
        <div className="mt-16 bg-gray-50 rounded-xl p-8 md:p-12" data-id="element-360">
          <div className="flex flex-col md:flex-row items-center" data-id="element-361">
            <div className="w-full md:w-2/3 mb-8 md:mb-0 md:pr-12" data-id="element-362">
              <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-363">
                Our Process Makes Technology Simple
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-364">
                We take the complexity out of technology by following a proven
                process designed to deliver exceptional results with minimal
                disruption to your home or business.
              </p>
              <div className="space-y-4" data-id="element-365">
                {[{
                number: '01',
                title: 'Consultation & Design',
                desc: 'We learn your needs and create a custom solution'
              }, {
                number: '02',
                title: 'Professional Installation',
                desc: 'Expert technicians install with precision and care'
              }, {
                number: '03',
                title: 'System Programming',
                desc: 'Custom programming for intuitive control'
              }, {
                number: '04',
                title: 'Training & Support',
                desc: "We ensure you're comfortable with your new technology"
              }].map((step, idx) => <div key={idx} className="flex" data-id="element-366">
                    <div className="mr-4 bg-blue-600 rounded-full w-10 h-10 flex items-center justify-center flex-shrink-0" data-id="element-367">
                      <span className="text-white font-bold" data-id="element-368">
                        {step.number}
                      </span>
                    </div>
                    <div data-id="element-369">
                      <h4 className="font-bold text-gray-800" data-id="element-370">{step.title}</h4>
                      <p className="text-gray-600 text-sm" data-id="element-371">{step.desc}</p>
                    </div>
                  </div>)}
              </div>
            </div>
            <div className="w-full md:w-1/3" data-id="element-372">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1aajRYC6DBrUabo7bRuUJ3/smarthomesystem.jpg" alt="Smart home control panel with lighting, security, temperature and camera controls" className="rounded-xl shadow-md w-full h-auto" data-id="element-373" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default WhyChooseUsSection;